
import { Vue, Component, Prop } from 'vue-property-decorator'
import { getBankList } from '@/service/step-four'
import * as api from '@/service/authentication'
import { bindBankQuery } from '@/service/step-four'
import { CreateElement } from 'vue'

@Component
export default class StepTwo extends Vue {
  @Prop({ required: true }) data!: any

  bankList: string[] = []
  bindBankSuccess = false
  bindBankQuering = false
  loading = false
  validateError = ''

  created() {
    this.getBankList()
    this.bindBankSuccess = !!this.data.bindBankSuccess
  }

  async getBankList() {
    this.bankList = await getBankList()
  }

  validateField(field: string) {
    const formRef: any = this.$refs.form
    return new Promise((resolve, reject) => {
      formRef.validateField(field, (message: string) => {
        message ? reject(new Error(message)) : resolve(1)
      })
    })
  }

  async bindBank() {
    try {
      await (this.$refs.form as any).validate()
    } catch {
      this.$message.error('请完善必填信息')
      throw new Error('校验失败')
    }

    this.loading = true
    try {
      await api.bindBank(this.data)
      this.bindBankSuccess = true
    } catch (err) {
      this.$message.error('银行账号验证失败，请检查认证信息')
      this.$emit('back')
    }
    this.loading = false
  }

  async bindBankQuery() {
    this.bindBankQuering = true
    try {
      const { status, errorMsg } = await bindBankQuery()
      const result = ['成功', '失败', '处理中'][status - 1]
      this.$info({
        title: '查询结果',
        content: (h: CreateElement) =>
          h(
            'div',
            {
              style: 'text-align: left',
            },
            [
              h('p', `银行打款状态：${result}`),
              status === 2 && h('p', { style: 'color: #f5222d' }, errorMsg),
            ]
          ),
        okText: '知道了',
      })
    } catch {}
    this.bindBankQuering = false
  }

  async validate() {
    try {
      await Promise.all([
        this.validateField('sms_code'),
        this.validateField('amount'),
      ])
    } catch (error) {
      this.$message.error('请完善必填信息')
      throw error
    }

    this.loading = true
    try {
      const data = await api.bindBankVerify(
        this.data.amount,
        this.data.sms_code
      )
      if (data.tb_bind_status === 2) {
        throw new Error('输入金额与实际转入金额不一致！')
      }
      if (data.tb_bind_status === 3) {
        // 处理中
        await this.queryValidateResult(data.tb_bind_verify_seqid)
      }
      await api.signBehavior()
      this.$emit('forward')
    } catch (err) {
      this.validateError = err.message || err.msg
    }
    this.loading = false
  }

  queryValidateResult(seqId: string) {
    return new Promise((resolve, reject) => {
      window.setTimeout(async () => {
        try {
          const data = await api.bindVerifyQuery(seqId)
          if (data.tb_bind_status === 1) return resolve(1)
          if (data.tb_bind_status === 2)
            return reject(new Error(data.tb_bind_fail_msg))
          resolve(this.queryValidateResult(seqId))
        } catch (err) {
          reject(err)
        }
      }, 2000)
    })
  }
}
